// extracted by mini-css-extract-plugin
export default {"pageLayout":"JobProspectsStatsDetail-module__pageLayout___R8Otc"};